import React, { useEffect, useState } from "react";
import DashboardMain from "./DashboardMain";
import Complete from "./PickUpCash/Complete";

const STAGES = {
  HOME: 'home',
  LOGIN: 'login',
  HUB: 'hub',
  EMBED: 'embed',
  PICKUP: 'pickup',
  COMPLETE: 'complete',
};

const DEMO_CENTER = { lat: 34.1655, lng: -118.372 };
const DEMO_BUSINESSES = [
  {
    registration_id: 'demo-1',
    business_name: 'Magnolia Cash Mart',
    latitude: 34.1672,
    longitude: -118.37,
    address: '11000 Magnolia Blvd, North Hollywood, CA 91601',
  },
  {
    registration_id: 'demo-2',
    business_name: 'NoHo Cash Stop',
    latitude: 34.1629,
    longitude: -118.3741,
    address: '5235 Lankershim Blvd, North Hollywood, CA 91601',
  },
  {
    registration_id: 'demo-3',
    business_name: 'Chandler Pickup Point',
    latitude: 34.1647,
    longitude: -118.3795,
    address: '11330 Chandler Blvd, North Hollywood, CA 91601',
  },
];

function ChaseDemoFlow({ history }) {
  const [stage, setStage] = useState(STAGES.HOME);
  const [pickupDetails, setPickupDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const spareLogo = `${process.env.PUBLIC_URL || ''}/images/spare_logo_s.png`;
  const isHomeScreen = stage === STAGES.HOME;

  useEffect(() => {
    if (stage !== STAGES.PICKUP) {
      return undefined;
    }
    const pickupTimer = setTimeout(() => {
      setStage(STAGES.COMPLETE);
    }, 60000);
    return () => clearTimeout(pickupTimer);
  }, [stage]);

  useEffect(() => {
    if (stage !== STAGES.COMPLETE) {
      return undefined;
    }
    const completeTimer = setTimeout(() => {
      setPickupDetails(null);
      setStage(STAGES.HUB);
    }, 10000);
    return () => clearTimeout(completeTimer);
  }, [stage]);
  const renderFooterNav = (active = 'accounts') => (
    <div className="chase-demo__footer">
      {['accounts', 'pay', 'spare', 'invest', 'more'].map((label) => (
        <button
          key={label}
          type="button"
          className={label === active ? 'active' : ''}
        >
          {label === 'pay' ? 'Pay & Transfer'
            : label === 'spare' ? 'Spare'
            : label === 'invest' ? 'Investing'
            : label === 'more' ? 'More'
            : 'Accounts'}
        </button>
      ))}
    </div>
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (!credentials.username || !credentials.password) {
      return;
    }
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setStage(STAGES.HUB);
    }, 900);
  };

  const renderLogin = () => (
    <form className="chase-demo__panel" onSubmit={handleLogin}>
      <h2>Sign In</h2>
      <label>
        Username
        <input
          name="username"
          type="text"
          value={credentials.username}
          onChange={handleInputChange}
          placeholder="demo_user"
          required
        />
      </label>
      <label>
        Password
        <input
          name="password"
          type="password"
          value={credentials.password}
          onChange={handleInputChange}
          placeholder="DemoPass123!"
          required
        />
      </label>
      <button type="submit" className="chase-demo__primary-btn" disabled={isLoading}>
        {isLoading ? 'Signing In…' : 'Sign In'}
      </button>
    </form>
  );

  const renderHome = () => (
    <div className="chase-demo__home">
      <div className="chase-demo__home-grid">
        <button
          type="button"
          className="chase-demo__app-tile"
          onClick={() => setStage(STAGES.LOGIN)}
        >
          <span className="chase-demo__app-icon">🏦</span>
          <span className="chase-demo__app-label">Bank App</span>
        </button>
      </div>
      <div className="chase-demo__home-dock">
        <div className="chase-demo__dock-hint" />
      </div>
    </div>
  );

  const renderHub = () => (
    <>
    <div className="chase-hub">
      <section className="chase-hub__hero">
        <div>
          <p className="chase-hub__eyebrow">TOTAL CHECKING •••• 2234</p>
          <h2>$8,542.12</h2>
          <p className="chase-hub__subtext">Available balance today</p>
        </div>
        <button type="button">Pay</button>
      </section>
      <section className="chase-hub__insights">
        <article>
          <p>Spend this week</p>
          <h3>$412.87</h3>
          <span>Down 12% vs last week</span>
        </article>
        <article>
          <p>Rewards</p>
          <h3>18,420 pts</h3>
          <span>+$120 pending</span>
        </article>
      </section>
      <section className="chase-hub__apps">
        <p className="chase-hub__eyebrow">Connected apps</p>
        <button type="button" className="chase-hub__app" onClick={() => setStage(STAGES.EMBED)}>
          <img src={spareLogo} alt="Spare logo" />
          <div>
            <strong>Spare</strong>
          </div>
        </button>
        <div className="chase-hub__app chase-hub__app--disabled">
          <div className="chase-hub__app-icon">+</div>
          <div>
            <strong>Connect more</strong>
            <span>Coming soon</span>
          </div>
        </div>
      </section>
    </div>
    {renderFooterNav('accounts')}
    </>
  );

  const renderEmbed = () => (
    <div className="chase-demo__embed-wrapper">
      <div className="chase-demo__embed-header">
        <span type="button" className="demo-close" onClick={() => setStage(STAGES.HUB)} style={{padding: "10px", color: "white"}}>←</span>
      </div>
      <div className="chase-demo__embed-body">
          <div className="chase-demo__embed-frame">
            <div className="chase-demo__iframe-shell">
              <DashboardMain demoOptions={{
                skipUserLocationFetch: true,
                disableAccountRequests: true,
                initialCenter: DEMO_CENTER,
                initialAddress: 'North Hollywood, CA 91601',
                initialZipcode: '91601',
                initialRequestedAmount: 250,
                initialBalance: 8542.12,
                initialBusinesses: DEMO_BUSINESSES,
                embedMobileLayout: true,
                hideAddBalanceButton: true,
                hideHeader: true,
                onlyDashboardWithActions: true,
                onDemoPickupSelect: (details) => {
                  setPickupDetails(details);
                  setStage(STAGES.PICKUP);
                },
              }} />
            </div>
          </div>
      </div>
      {renderFooterNav('spare')}
    </div>
  );

  const handleCancelPickup = () => {
    setPickupDetails(null);
    setStage(STAGES.EMBED);
  };

  const renderFeeRow = (label, value) => (
    <div className="pickup-demo__fee-row">
      <span>{label}</span>
      <strong>${value}</strong>
    </div>
  );

  const renderPickup = () => (
    <div className="chase-demo__embed-wrapper">
      <div className="chase-demo__embed-header">
      <div className="chase-demo__embed-header">
        <span type="button" className="demo-close" onClick={() => setStage(STAGES.EMBED)} style={{padding: "10px", color: "white"}}>←</span>
      </div>
      </div>
      <div className="chase-demo__embed-body">
        <div className="chase-demo__embed-frame">
          <div className="chase-demo__iframe-shell">
            <div className="pickup-demo">
              <div className="pickup-demo__card">
                <div className="pickup-demo__merchant-block">
                  <div>
                    <p className="pickup-demo__eyebrow">Picking up from</p>
                    <h3>{pickupDetails?.merchant || 'Magnolia Cash Mart'}</h3>
                    <span>{pickupDetails?.address || '11000 Magnolia Blvd, North Hollywood, CA 91601'}</span>
                  </div>
                  <div className="pickup-demo__amount">
                    <p>Amount</p>
                    <h2>${pickupDetails?.amount || 250}</h2>
                  </div>
                </div>
                <div className="pickup-demo__status">
                  <small>Show this PIN to the agent.</small>
                  <div className="pickup-demo__code">{pickupDetails?.code || 'SPARE-9420'}</div>
                  <button className="btn btn-primary" style={{margin: "5px 0px", borderRadius: "30px"}}>Scan QR Code</button>
                  <span className="pickup-demo__status-tag">Awaiting agent confirmation</span>
                </div>
                <div className="pickup-demo__fees">
                  {renderFeeRow('Pickup amount', pickupDetails?.amount || 5)}
                  {renderFeeRow('Location fee', pickupDetails?.fee || 3)}
                  <hr />
                  {renderFeeRow('Total due today', (pickupDetails?.amount || 5) + (pickupDetails?.fee || 3))}
                </div>
                <div className="pickup-demo__instructions">
                  <p>Next steps</p>
                  <ul>
                    <li>Bring your government-issued ID.</li>
                    <li>Give the code to the cashier and confirm the amount.</li>
                  </ul>
                </div>
                <div className="pickup-demo__actions">
                  <button type="button" className="danger" onClick={handleCancelPickup}>Cancel pickup</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {renderFooterNav('spare')}
    </div>
  );

  const renderComplete = () => (
    <div className="chase-demo__embed-wrapper">
      <div className="chase-demo__embed-header">
        <span type="button" className="demo-close" onClick={() => setStage(STAGES.HUB)} style={{padding: "10px", color: "white"}}>←</span>
      </div>
      <div className="chase-demo__embed-body">
        <div className="chase-demo__embed-frame">
          <div className="chase-demo__iframe-shell">
            <Complete history={history} />
          </div>
        </div>
      </div>
      {renderFooterNav('spare')}
    </div>
  );

  const renderContent = () => {
    switch (stage) {
      case STAGES.HOME:
        return renderHome();
      case STAGES.LOGIN:
        return (
          <>
            {renderLogin()}
          </>
        );
      case STAGES.HUB:
        return renderHub();
      case STAGES.PICKUP:
        return renderPickup();
      case STAGES.COMPLETE:
        return renderComplete();
      case STAGES.EMBED:
      default:
        return renderEmbed();
    }
  };

  return (
    <div className="chase-demo">
      <div className="chase-demo__background" />
      <div className="chase-demo__phone">
        <div className="chase-demo__notch" />
        <header className="chase-demo__status">
          <span>{isHomeScreen ? '9:41' : '\t'}</span>
          <span
            type="button"
            className="chase-demo__status-marks"
            onClick={!isHomeScreen ? () => setStage(STAGES.LOGIN) : undefined}
            aria-label={isHomeScreen ? 'Home screen indicators' : 'Back to demo login'}
          >
            <span />
            <span />
            <span />
          </span>
        </header>
        {renderContent()}
      </div>
    </div>
  );
}

export default ChaseDemoFlow;
